import React from 'react';
import ComboBox from '../../../components/ComboBox/ComboBox';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import * as microphoneActions from '../../../../redux/microphone/actions.microphone';
import _ from 'lodash';
import VersionTagItem from '../VersionTagItem/VersionTagItem';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import RenameProjectTagForm from '../RenameProjectTagForm/RenameProjectTagForm';
import ReactTooltip from 'react-tooltip';
import { isCiCdTag } from '../../../../services/mini/isCiCdTag';

class ProjectTagSelector extends React.PureComponent {
  onProjectTagSelect = (tag) => {
    const { project, environment } = this.props;

    if (environment) {
      if (project[`${environment}TagId`] !== tag.tagId) {
        this.props.setProjectTag({
          project,
          tagId: tag.tagId,
          environment,
          checkForUnsaved: true,
        });
        this.props.stopMicrophone();
      }
    }
  };

  renameTag = (tagId) => {
    const { project, renameTag, environment } = this.props;
    const currentTag = _.find(project.tags, { tagId: tagId });
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <RenameProjectTagForm
            project={project}
            tagName={currentTag.message}
            tagId={tagId}
            environment={environment}
            selectedStageTagId={tagId}
            renameTag={renameTag}
            onClose={onClose}
          />
        );
      },
    });
  };

  deleteTag = (tagId) => {
    const { project, deleteTag, environment } = this.props;
    const currentTag = _.find(project.tags, { tagId: tagId });

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmPopup
            onClose={onClose}
            okBtnLabel="Delete"
            okBtnCb={() => {
              deleteTag(project, tagId, environment);
              onClose();
            }}
            type="delete"
            title="Delete Version"
            message={`Are you sure you want to delete “${currentTag.message}” version?`}
          />
        );
      },
    });
  };

  render() {
    const { project, environment, className } = this.props;

    const selectedTagId = project[`${environment}TagId`];
    const selectedTag = _.find(project.tags, { tagId: selectedTagId });

    if (!project?.projectId) {
      return <React.Fragment />;
    }

    const tags = project.tags.filter(tag => !isCiCdTag(tag));

    return (
      <React.Fragment>
        <ReactTooltip id="deleteTagIsDisabled" />

        <ComboBox
          values={tags}
          valueKey="tagId"
          selectedValueId={selectedTagId}
          onValueSelect={this.onProjectTagSelect}
          valueName="message"
          environment={`${className} ${environment}`}
          classes={`project-header_tag-cb ${environment} ${className}`}
          tooltipMsg={`Selected version will run on the<br/> ${environment[0].toUpperCase() + environment.slice(1)
            } server`}
          tooltipId="versionCbTooltip"
          renderItem={(tag, inList, closeComboBoxCb) => {
            return (
              <VersionTagItem
                tag={tag}
                prodTagId={project.prodTagId}
                stageTagId={project.stageTagId}
                testingTagId={project.testingTagId}
                inList={inList}
                selectedTagId={selectedTagId}
                onEdit={(tagId, e) => {
                  this.renameTag(tagId);
                  closeComboBoxCb(e);
                }}
                onDelete={(tagId, e) => {
                  if (tag.tagId !== project.prodTagId) {
                    this.deleteTag(tagId);
                    closeComboBoxCb(e);
                  }
                }}
              />
            );
          }}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps({ projectsInfo }, ownProps) {
  return {
    project: projectsInfo.currentProject,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    stopMicrophone: () => dispatch(microphoneActions.stopMicrophone()),
    setProjectTag: (param) => dispatch(actions.setProjectTag(param)),
    renameTag: (project, tagId, tagName, environment) =>
      dispatch(actions.renameTag(project, tagId, tagName, environment)),
    deleteTag: (project, tagId, environment) =>
      dispatch(actions.deleteTag(project, tagId, environment)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTagSelector);
